import styled from 'styled-components';
import tw, { css } from 'twin.macro';
import { Meta, Body } from '../../styled components/Typography';

export const TimesheetEntryItemCard = styled.div(({ $variant }) => [
  tw`pl-12 relative`,
  $variant === 'break'
    ? tw`border-orange-base border-l-4 border-dotted pl-8`
    : css`
        &:before {
          content: '';
          ${tw`absolute left-0 top-0 w-4 h-full bg-black rounded`}
        }
      `,
  $variant === 'shift' &&
    css`
      &:before {
        ${tw`bg-orange-base`}
      }
    `
]);

export const TimesheetEntryItemCardInfo = styled.div(
  ({ $variant, $shiftPart, $fillSpaceReservedForFeedbackMessage = true, $isReadOnly }) => [
    tw`flex justify-between`,
    $isReadOnly ? tw`gap-16` : tw`gap-8`,
    $variant === 'shift' && $shiftPart === 'start' && tw`items-start `,
    $variant === 'shift' && $shiftPart === 'end' && tw`items-end `,
    $fillSpaceReservedForFeedbackMessage && $shiftPart === 'start' && tw`pb-24`,
    $fillSpaceReservedForFeedbackMessage && $shiftPart === 'end' && tw`pt-24`
  ]
);

export const TimesheetEntryTitle = styled(Body).attrs(() => ({
  as: 'h2',
  $color: 'black'
}))(({ $variant }) => [
  tw` block break-all`,
  ($variant === 'shift' || $variant === 'break') && tw`text-orange-base`
]);

export const TimesheetEntryTimesWrapper = styled.div(({ $isReadOnly, $variant }) => [
  tw`space-y-8 shrink-0`,
  $isReadOnly && $variant !== 'shift' && tw`pb-8`
]);

export const TimesheetEntrySubText = styled(Meta).attrs(() => ({
  $color: 'gray dark'
}))(() => [tw`block break-all`]);
